import { Tabs as MuiTabs, TabsProps as MuiTabsProps } from '@mui/material'
import styled from 'styled-components'

export type TabsPropsType = MuiTabsProps

const Tabs = styled(MuiTabs)<TabsPropsType>``

export default Tabs
